import CookieService from '../services/cookies'
import http from '../services/axios'

import {
  GET_HTTP_CONFIG,
  GET_BACKEND_URL,
  AUTH_HEADER_TOKEN,
  DELIVERY_TOKEN_HEADER_KEY,
  LOADING_PRISTINE,
  LOADING_STARTED,
  LOADING_COMPLETED_SUCCESS,
  LOADING_COMPLETED_FAILURE,
  LOAD_SESSION_FROM_COOKIE,
  SET_SESSION,
  SESSION_COOKIE_KEY,
  LOGOUT,
  LOGIN,
  SIGNUP,
  INIT_USER_MODULE,
  GET_SESSION_TOKEN,
  GET_PROFILE_DROPDOWN_TEXT,
  GET_IS_LOGGED_IN,
  GET_IS_SIGNUP_PROCESS_LOADING,
  LOAD_USER,
  SET_USER,
  SET_SIGNUP_STATE,
  INIT_AUTHENTICATED_STORE,
  INIT_AUTHENTICATED_USER_MODULE,
  SET_LOGIN_DROPDOWN_STATE,
  LOAD_STUDIES_OF_USER,
  SET_EMAIL_CONFIRMATION_STATE,
  SET_EMAIL_RESEND_STATE,
  RESEND_CONFIRMATION_EMAIL,
  R_NAME_HOME,
  R_NAME_DASHBOARD,
  SET_LOGIN_REDIRECT,
  RESET_LOGIN_REDIRECT,
  LOAD_PURCHASES_OF_USER,
  SET_RESET_PASSWORD_STATE,
  SET_RESET_PASSWORD_SHOW_STATE,
  RESET_PASSWORD,
  RESET_THE_RESET_PASSWORD,

} from '../services/constants'

const module = {
  state: {
    session: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    user: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    signupState: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    resetPasswordState: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    loginDropdownShowState: false,
    resetPasswordShowState: false,
    loginRedirect: {name: R_NAME_DASHBOARD},
    emailConfirmationShowState:false,
    resendEmailState: LOADING_PRISTINE,
  },
  getters: {
    [GET_SESSION_TOKEN](state) {
      return state.session.data
    },
    [GET_IS_LOGGED_IN](state, getters) {
      return !!getters[GET_SESSION_TOKEN]
    },
    [GET_PROFILE_DROPDOWN_TEXT](state) {
      return state.user.loadingState === LOADING_COMPLETED_SUCCESS ? state.user.data.username : ''
    },
    [GET_IS_SIGNUP_PROCESS_LOADING](state) {
      return state.signupState.loadingState === LOADING_STARTED
        || state.session.loadingState === LOADING_STARTED
    }
  },
  mutations: {
    [SET_SESSION]: (state, payload) => {
      state.session = payload
      if (state.session.data) {
        CookieService.set(SESSION_COOKIE_KEY, state.session.data)
      } else {
        CookieService.removeByKey(SESSION_COOKIE_KEY)
      }
    },
    [SET_USER]: (state, payload) => {
      state.user = payload
    },
    [SET_SIGNUP_STATE]: (state, payload) => {
      state.signupState = payload
    },
    [SET_LOGIN_DROPDOWN_STATE]: (state, payload) => {
      state.resetPasswordShowState = false
      state.resetPasswordState = {
        loadingState: LOADING_PRISTINE,
        data: null,
        error: null,
      }
      state.loginDropdownShowState = payload
    },
    [SET_RESET_PASSWORD_SHOW_STATE]: (state, payload) => {
      state.resetPasswordShowState = payload
    },
    [SET_RESET_PASSWORD_STATE]: (state, payload) => {
      state.resetPasswordState = payload
    },
    [SET_EMAIL_CONFIRMATION_STATE]: (state, payload) => {
      state.emailConfirmationShowState = payload
    },
    [SET_EMAIL_RESEND_STATE]: (state, payload) => {
      state.resendEmailState = payload
    },
    [SET_LOGIN_REDIRECT]: (state, payload) => {
      state.loginRedirect = payload
    },
    [RESET_LOGIN_REDIRECT]: (state) => {
      state.loginRedirect = {name: R_NAME_DASHBOARD}
    },
  },
  actions: {
    [LOAD_SESSION_FROM_COOKIE]: (context) => {
      const token = CookieService.getByKey(SESSION_COOKIE_KEY)
      context.commit(SET_SESSION, {
        loadingState: context.state.session.loadingState,
        data: token,
        error: context.state.session.error,
      })
    },
    [LOGIN]: (context, payload) => {
      context.commit(SET_SESSION, {
        loadingState: LOADING_STARTED,
        data: context.state.session.data,
        error: context.state.session.error,
      })
      return http.post(context.getters[GET_BACKEND_URL](`user/login`), payload).then(response => {
        if (response.data.success) {
          context.commit(SET_SESSION, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data.token,
            error: null,
          })
          return context.dispatch(INIT_AUTHENTICATED_STORE)
        } else {
          throw new Error(response.data.message)
        }
      }).catch(err => {
        console.error(err)
        context.commit(SET_SESSION, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err.message,
        })
      })
    },
    [LOGOUT]: (context) => {
      context.commit(SET_SESSION, {
        state: LOADING_PRISTINE,
        data: null,
        error: null,
      })
      context.commit(SET_EMAIL_CONFIRMATION_STATE, false)

    },
    [SIGNUP]: (context, payload) => {
      context.commit(SET_SIGNUP_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.signupState.data,
        error: context.state.signupState.error,
      })
      return http.post(context.getters[GET_BACKEND_URL](`user`), payload).then(response => {
        if (response.data.success) {
          context.commit(SET_SIGNUP_STATE, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data.token,
            error: null,
          })
        } else {
          throw new Error(response.data.message)
        }
      }).catch(err => {
        console.error(err)
        context.commit(SET_SIGNUP_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err.message,
        })
      })
    },
    [RESET_PASSWORD]: (context, emailAddress) => {
      context.commit(SET_RESET_PASSWORD_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.resetPasswordState.data,
        error: context.state.resetPasswordState.error,
      })
      return http.post(context.getters[GET_BACKEND_URL](`user/pass-reset-email?email=${emailAddress}`), {}).then(response => {
        console.log(response)
        context.commit(SET_RESET_PASSWORD_STATE, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })
      }).catch(err => {
        console.error(err)
        context.commit(SET_RESET_PASSWORD_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err.message,
        })
      })
    },
    [LOAD_USER](context) {
      context.commit(SET_USER, {
        loadingState: LOADING_STARTED,
        data: context.state.session.data,
        error: context.state.session.error,
      })
      return http.get(context.getters[GET_BACKEND_URL](`user/get`), context.getters[GET_HTTP_CONFIG]).then(response => {
        context.commit(SET_USER, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })
        context.commit(SET_EMAIL_CONFIRMATION_STATE, response.data.status === 0)
      }).catch(err => {
        console.error(err)
        context.commit(SET_USER, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err.message,
        })
      })
    },
    [RESEND_CONFIRMATION_EMAIL](context) {
      context.commit(SET_EMAIL_RESEND_STATE, LOADING_STARTED)
      return http.post(context.getters[GET_BACKEND_URL](`user/resend/verification`), {}, context.getters[GET_HTTP_CONFIG])
        .then(() => {
          context.commit(SET_EMAIL_RESEND_STATE, LOADING_COMPLETED_SUCCESS)
          setTimeout(() => { context.commit(SET_EMAIL_RESEND_STATE, LOADING_PRISTINE) }, 3000);
         })
        .catch(() => {
          context.commit(SET_EMAIL_RESEND_STATE, LOADING_COMPLETED_FAILURE)
          setTimeout(() => { context.commit(SET_EMAIL_RESEND_STATE, LOADING_PRISTINE) }, 3000);
        })
    },
    [INIT_USER_MODULE]: (context) => {
      return http.all([
        context.dispatch(LOAD_SESSION_FROM_COOKIE)
      ])
    },
    [INIT_AUTHENTICATED_USER_MODULE]: (context) => {
      return http.all([
        context.dispatch(LOAD_USER),
        context.dispatch(LOAD_STUDIES_OF_USER),
        context.dispatch(LOAD_PURCHASES_OF_USER)
      ])
    },
  }
}

export default module
export const userModule = module
